import styled from 'styled-components';

export const CounterContainer = styled.div`
  display: flex;
  border-radius: ${({ theme }) => theme.borderRadius};
  align-items: center;
  border: 1px solid #8f8f8f;
  justify-content: space-between;
  font-size: 0.8rem;
`;
